import { TFunction } from 'i18next';
import {
    DataPopulation,
    PanelTimePeriod,
    SiteAverage,
    StableVariableType,
    ThresholdCalculation,
} from 'types/graphql-global-types';

export type RowDataSource = {
    id: string;
    name: string;
    table: string;
};

export type YAxisData = {
    id: string;
    name: string;
};

export type SortByDate = {
    id: string;
    name: string;
};

export type DropdownOption = {
    id: string;
    name: string;
};

export type IFormData = {
    // Column 1
    isActive: boolean;
    configId: string;
    plotTitle: string;
    xAxisTitle: string;
    yAxisTitle: string;
    weight: number | null;
    includeInScoring: boolean;
    decision: boolean;

    // Column 2
    minRecordsSiteScore: number | null;
    rowData: RowDataSource | null;
    yAxisData: YAxisData | null;
    sortByDate: SortByDate | null;
    siteAverage: { id: SiteAverage; name: string } | null;
    dataPopulation: { id: DataPopulation; name: string } | null;

    // Column 3
    thresholdCalculation: { id: ThresholdCalculation; name: string } | null;
    amberThreshold: number | null;
    redThreshold: number | null;
    bigRedThreshold: number | null;
    dataInclusionUnit: { id: number; name: string } | null;
    dataInclusionPeriod: { id: PanelTimePeriod; name: string } | null;

    // Column 4
    stableVariableType: { id: StableVariableType; name: string } | null;
    stableVariableValue: number | null;
    greenMax: number | null;
    amberMax: number | null;
    yAxisColumn: string;
};

export const Options = (t: TFunction) => {
    return {
        SiteAverageOptions: [
            {
                id: SiteAverage.MEAN,
                name: t(SiteAverage.MEAN),
            },
            {
                id: SiteAverage.MEDIAN,
                name: t(SiteAverage.MEDIAN),
            },
        ],
        DataPopulationOptions: [
            { id: DataPopulation.ALL, name: t(DataPopulation.ALL) },
            { id: DataPopulation.MOST_RECENT, name: t(DataPopulation.MOST_RECENT) },
        ],
        ThresholdCalculationOptions: [
            { id: ThresholdCalculation.MEAN_SD, name: t(ThresholdCalculation.MEAN_SD) },
            { id: ThresholdCalculation.POISSON, name: t(ThresholdCalculation.POISSON) },
            { id: ThresholdCalculation.STUDY_SPECIFIC, name: t(ThresholdCalculation.STUDY_SPECIFIC) },
        ],
        StableTypeOptions: [
            { id: StableVariableType.NUMBER, name: t(StableVariableType.NUMBER) },
            { id: StableVariableType.PERCENTAGE, name: t(StableVariableType.PERCENTAGE) },
        ],
        DataInclusionUnits: Array.from(Array(30).keys()).map((item: number) => ({
            id: item + 1,
            name: `${item + 1}`,
        })),
        DataInclusionPeriodOptions: [
            { id: PanelTimePeriod.DAYS, name: t(PanelTimePeriod.DAYS) },
            { id: PanelTimePeriod.WEEKS, name: t(PanelTimePeriod.WEEKS) },
            { id: PanelTimePeriod.MONTHS, name: t(PanelTimePeriod.MONTHS) },
            { id: PanelTimePeriod.QUARTERS, name: t(PanelTimePeriod.QUARTERS) },
            { id: PanelTimePeriod.YEARS, name: t(PanelTimePeriod.YEARS) },
        ],
    };
};
